import ICONS from "../icons";
import { testimonials } from "../../data/siteContent";

export const Testimonials = () => (
  <section
    className="section testimonials"
    id="testimonials"
    data-testid="testimonials-section"
  >
    <div className="section-heading" data-testid="testimonials-heading">
      <h2 data-testid="testimonials-title">Real results, in their own words</h2>
      <p data-testid="testimonials-subtitle">
        A snapshot of what happens once your brand, content and consistency
        come together.
      </p>
    </div>
    <div className="testimonial-grid" data-testid="testimonials-grid">
      {testimonials.map((testimonial) => (
        <div
          className="testimonial-card"
          key={testimonial.name}
          data-testid={testimonial.testid}
        >
          <ICONS.Quote className="testimonial-quote-icon" aria-hidden="true" />
          <p data-testid={`${testimonial.testid}-quote`}>{testimonial.quote}</p>
          <div className="testimonial-meta" data-testid={`${testimonial.testid}-meta`}>
            <span data-testid={`${testimonial.testid}-name`}>{testimonial.name}</span>
            <span data-testid={`${testimonial.testid}-role`}>{testimonial.role}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
);
